export default __webpack_public_path__ + "static/media/Diviner's Armbands of the Emissary.968546ee.jpg";